import ApiService from './api.service'

const TenantService = {
  async getTenantInfo(tenantId) {
    try {
      return await ApiService.get(`tenant/${tenantId}`)
    } catch (error) {
      console.error('Error fetching tenant info:', error)
      return error
    }
  },

  async getTenantModules(countryCode = null) {
    try {
      const url = countryCode ? `tenant/modules?tenant=${countryCode}` : 'tenant/modules'
      return await ApiService.get(url)
    } catch (error) {
      console.error('Error fetching tenant modules:', error)
      return error
    }
  },

  getCurrentTenantId() {
    const tenancyEnabled = process.env.VUE_APP_TENANCY === 'true'

    if (tenancyEnabled) {
      const tenancyLocal = process.env.VUE_APP_TENANCY_LOCAL === 'true'
      if (tenancyLocal) {
        return process.env.VUE_APP_TENANCY_COUNTRY || null
      }
      return null
    }

    return null
  }
}

export default TenantService
